import React from "react";
import PropTypes from "prop-types";

const DiseaseFundLoading = ({ title }) => {
  return (
    <div className="Page-banner hasCard">
      <div className="Page-banner-titleContainer">
        <h1 className="Page-banner-pageTitle f-pageTitle-sans u-mb1">
          {title}
        </h1>
      </div>

      <div className="Page-banner-card">
        <div className="Card bg-coral-light-50">
          <div className="Card-inner">
            <div className="Card-inner-content">
              <div className="Loading Loading--coral-light-50">
                <div className="Loading-spinner"></div>
                <p className="f-h6 c-default u-mt1">
                  Confirming Disease Fund availability
                </p>
                <p className="f-h6 c-default">Please Wait</p>
              </div>
              <p className="u-center">
                If this status persists, please call{" "}
                <a href="tel:18663167263">1-866-316-7263</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DiseaseFundLoading.propTypes = {
  title: PropTypes.string.isRequired,
};

export default DiseaseFundLoading;
